<template>
  <master-page icone="mdi-calendar-check" titulo="Atividades de captação">
    <v-card class="ma-4"><v-card-title>Atividades de captação</v-card-title><v-card-text><atividades-crm /></v-card-text></v-card>
  </master-page>
</template>
<script>
import AtividadesCrm from '@/components/doacao/oportunidade/Atividades.vue';

export default { components: { AtividadesCrm } };
</script>
